import { useParams } from 'react-router';

import { MediaLibraryResults } from '~components/search/MediaLibraryResults';

export function MediaLibraryResultsController() {
  const { term } = useParams();
  return <MediaLibraryResults searchTerm={term} />;
}
